import React from "react";
import Auxiliary from "../HOC/Auxiliary";
import logo from "../../Assets/googlelogo.png";
import API_KEY from "../../Config/keys";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import "./Body.css";
import SearchInput from "../SearchInput/SearchInput";

const CONTEXT_KEY =  "1ad1c230bfd086df4";
// import useGoogleSearch from "../../Config/useGoogleSearch"; //CUSTOM HOOK
const Body=(props)=>{
        const startSearching = ()=>{
             
            const fetchData = async()=>{
                
                fetch(
                    `https://www.googleapis.com/customsearch/v1?key=${API_KEY}&cx=${CONTEXT_KEY}&q=${props.term.trim().toLowerCase()}`
                ).then(response => response.json())
                .then(result => {
                    props.history.push("/search-results/all");
                    props.updateData(result);
                        
                })
            }
            if(props.term && props.term !== ""){
                fetchData();
            }
        }
        return(
            <Auxiliary>
                <div id="homeBody"className="body_container flex-column">
                    <div className="body_inner flex-column">
                        <img className="logo" src={logo} alt="google logo" />
                        <SearchInput />
                        <div className="flex-row search-btns">
                           <button type="submit" onClick={()=> startSearching()}>Google search</button>
                            <button>I'm feeling lucky</button> 
                        </div>
                        
                    </div>
                </div>
            </Auxiliary>
        )
    
}
const dispatchStateToProps= dispatch=>{
    return{
        updateData : (payload) => dispatch({type: "UPDATE_DATA", payload:payload})
    }
}
const mapStateToProps = state=>{
    return{
        term: state.termInserted
    }
}

export default connect(mapStateToProps,dispatchStateToProps) (withRouter(Body));